import { createContext, useContext, useState } from 'react';

const LeadsContext = createContext(null);

export function LeadsProvider({ children }) {
  const [paraKanban, setParaKanban]   = useState(null); // leads aguardando virar card
  const [paraDisparo, setParaDisparo] = useState(null); // leads aguardando ir pro disparo

  return (
    <LeadsContext.Provider value={{ paraKanban, setParaKanban, paraDisparo, setParaDisparo }}>
      {children}
    </LeadsContext.Provider>
  );
}

export const useLeads = () => useContext(LeadsContext);
